import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const DocumentService = {
  upload: async (body: FormData) => {
    return await api.postFormData(`/documents`, body, { method: "POST" });
  },

  find: async () => {
    return await api.get(`/documents`);
  },

  delete: async (id: string) => {
    return await api.delete(`/documents/${id}`);
  },
};
export default DocumentService;
